<template>
  <div class="banner_container">
    <swiper
      :modules="modules"
      :centeredSlides="true"
      loop
      class="banner_wrapper"
      :class="'banner_wrapper_full'"
      :pagination="pagination"
    >
      <swiper-slide v-for="(item, index) in bannerList" :key="index" @click="skipHandle(item.linkStatus, item.appUrl)">
        <img :src="item.imgUrl" class="banner_img" />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script lang="ts" setup>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Autoplay, Pagination } from 'swiper'
import { CommunityBanners } from '@/api/Models/CommunityBanners'
import { useThemeColor } from '@/utils/theme'
// import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'
defineProps<{
  bannerList: CommunityBanners[]
}>()
const modules = [Autoplay, Pagination]
const themeColor = useThemeColor()
const pagination = {
  clickable: true,
  renderBullet(index: number, className: string) {
    return '<span class="' + className + '"></span>'
  }
}
// const router = useRouter()
const skipHandle = (linkStatus: string, appUrl: string) => {
  if (linkStatus) {
    handleExternalUrl({ jumpUrl: appUrl })
    // router.push('/webview?url=' + encodeURIComponent(appUrl))
  }
}
</script>

<style lang="less" scoped>
.banner_container {
  margin-top: 14px;
  .banner_warpper {
    height: calc((100vw - 32px) * 0.408);
    border-radius: 8px;
  }

  .banner_img {
    width: 100%;
  }
  .banner_wrapper_full {
    margin: 0 0 12px;
    height: calc((100vw) * 0.408);
    border-radius: 8px;
    position: relative;
    .banner_img {
      border-radius: 0;
      height: 100%;
      object-fit: cover;
    }
  }
  :deep(.swiper-pagination) {
    position: absolute;
    bottom: 12px;
    left: 12px;
    z-index: 10;
    display: flex;
    align-items: center;
  }
  :deep(.swiper-pagination-bullet) {
    width: 8px;
    height: 2px;
    background: #ffffff;
    border-radius: 1px;
    margin-right: 4px;
  }
  :deep(.swiper-pagination-bullet-active) {
    width: 8px;
    height: 3px;
    border-radius: 2px;
    background: v-bind(themeColor);
  }
}
</style>
